import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { CriterionsService, PAGE_SIZE } from '../../../services/criterions.service';
import { BehaviorSubject, finalize, Observable, takeUntil } from 'rxjs';
import { PagingResponse } from '../../../models/paging-response.model';
import { MemberCriterionInformation } from '../../../models/criterion-information.mode';
import { PageEvent } from '@angular/material/paginator';
import { CopyModel } from '../../../models/copy.model';
import { MatDialog } from '@angular/material/dialog';
import { AddEditSummaryComponent } from '../add-edit-summary/add-edit-summary.dialog';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import _cloneDeep from 'lodash/cloneDeep';
import { MemberModel } from '../../../models/member.model';
import { ICriterion } from '../../../../distribute-team-members/models/criterion';
import { ItimadCriterionsService } from '../../../services/itimad-criterions.service';

@Component({
  selector: 'app-summary-filter',
  templateUrl: './summary-filter.component.html',
  styleUrls: ['./summary-filter.component.scss', '../../data-table.scss']
})
export class SummaryFilterComponent extends BaseComponent implements OnInit {
  @Input() filter: string;
  @Output() onCloseFilter = new EventEmitter();
  pageSize = PAGE_SIZE;
  selectedPage = 0;
  totalItems = 0;

  members$: Observable<MemberModel[]>;
  criterion$: Observable<ICriterion[]>;

  decisionInput$ = this.criterionsService.decisionInputs$;
  visitMetaData = this.criterionsService.decisionInputs$.getValue().visitMetaData;
  isMasar = this.criterionsService.decisionInputs$.getValue().isMasar;
  isLoadingResults: boolean = false;

  dataSource$ = new BehaviorSubject<PagingResponse<MemberCriterionInformation>>(null);
  displayedColumns: string[];

  filtersForm: FormGroup;

  dir: "rtl" | "ltr" = this.translateService.currentLang == 'ar' ? 'rtl' : 'ltr';

  constructor(private criterionsService: CriterionsService,
    private itimadCriterionsService: ItimadCriterionsService,
    private translateService: TranslateService,
    private matDialog: MatDialog,
    private fb: FormBuilder) { super(); }

  ngOnInit() {
    this.displayedColumns = [
      this.filter,
      'criterionKey',
      'member',
      'actions'
    ];
    this.members$ = this.itimadCriterionsService.getMembersByVisitKey(this.visitMetaData.visitKey);
    this.criterion$ = this.itimadCriterionsService.getStickQuestionByVisitKey(this.visitMetaData.visitKey);
    this.initFilterForm();
    this.onSearch();
  }

  show(item: MemberCriterionInformation) {
    this.matDialog.open(AddEditSummaryComponent, {
      width: 'min(80%,900px)',
      direction: this.dir,
      maxHeight: '90vh',
      autoFocus: false,
      restoreFocus: false,
      data: {
        isViewOnly: true,
        summary: item[this.filter],
        memberArabicName: item.memberArabicName,
        memberEnglishName: item.memberEnglishName,
        dir: this.dir
      }
    })
  }
  copy(item: MemberCriterionInformation) {
    this.criterionsService.sendSummary$.next(new CopyModel(this.filter, item[this.filter]));
  }
  onClose() { this.onCloseFilter.emit(); }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.selectedPage = event.pageIndex;
    this.onSearch();
  }

  onSearch() {
    const values = _cloneDeep(this.filtersForm.value);
    const query = {
      ...(values.keyword
        ? { [`${this.filter}.contains`]: values.keyword }
        : { [`${this.filter}.notEquals`]: '' }
      ),
      ...(values.memberId
        ? { 'memberId.equals': values.memberId }
        : {}
      ),
      ...(values.criterionKey
        ? { 'criterionKey.equals': values.criterionKey }
        : {}
      )
    };
    this.getData(query);
  }
  onClear() {
    this.filtersForm.reset();
    this.onSearch();
  }

  private getData(query: any = {}) {
    this.isLoadingResults = true;
    const data = {
      'visitKey.equals': this.visitMetaData.visitKey,
      size: this.pageSize,
      page: this.selectedPage,
      ...query,
    };
    this.itimadCriterionsService
      .getCriterionInformationForAll(data)
      .pipe(
        finalize(() => this.isLoadingResults = false),
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        console.log(res);
        this.dataSource$.next(res);
      });
  }
  private initFilterForm(): void {
    this.filtersForm = this.fb.group({
      keyword: new FormControl(''),
      memberId: new FormControl(null),
      criterionKey: new FormControl('')
    });
  }
}
